/* Chop Source bundle comparison chart (sections/cs-kit-chart.liquid): header strip movement, shadows, part popups,
   hover photos. Popup content comes from the section (the chart's row entries and their products), in a JSON block.
   Built from the mockup in drafts/bundle-chart-mockup.html (2026-10-19). */
(function () {
  var sdaSupported = !!(window.CSS && CSS.supports('animation-timeline: --a') && CSS.supports('timeline-scope: --a'));
  var canHover = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;

  function init(section) {
    var chart = section.querySelector('[data-cs-kc]');
    if (!chart || chart.dataset.ready) return;
    chart.dataset.ready = '1';
    var body = chart.querySelector('.cs-kc__scroller');
    var head = chart.querySelector('.cs-kc__head');
    var sentinel = chart.querySelector('.cs-kc__sentinel');
    var headTable = head.querySelector('.cs-kc__t-head');
    var headPinned = head.querySelectorAll('.cs-kc__corner, .cs-kc__price th');
    var sheet = section.querySelector('.cs-kc-sheet');
    var peek = section.querySelector('.cs-kc-peek');
    var peekImg = peek.querySelector('img');

    // Popup content, keyed by row handle: name, blurb, price, img, links [[label, url]]
    var PARTS = {};
    try { PARTS = JSON.parse(section.querySelector('[data-cs-kc-parts]').textContent); } catch (e) {}

    // Header strip follows the table sideways: CSS where supported, otherwise the one-way script
    chart.classList.toggle('sda', sdaSupported);
    chart.classList.toggle('js-move', !sdaSupported);
    function moveHead(x) {
      headTable.style.transform = x ? 'translate3d(' + (-x) + 'px,0,0)' : '';
      for (var p = 0; p < headPinned.length; p++) headPinned[p].style.transform = x ? 'translate3d(' + x + 'px,0,0)' : '';
    }
    body.addEventListener('scroll', function () {
      var x = body.scrollLeft;
      if (!sdaSupported) moveHead(x);
      chart.classList.toggle('is-scrolled', x > 2);
      hidePeekNow();
    }, { passive: true });

    // Shadow under the header rows while they are stuck below the site header
    function stickyTop() {
      var cs = getComputedStyle(document.documentElement);
      return (parseFloat(cs.getPropertyValue('--header-height')) || 0) * (parseFloat(cs.getPropertyValue('--header-is-sticky')) || 0);
    }
    var ticking = false;
    function checkStuck() {
      ticking = false;
      var sticks = getComputedStyle(head).position === 'sticky';   // wide screens don't stick
      var top = stickyTop(), s = sentinel.getBoundingClientRect(), c = chart.getBoundingClientRect();
      head.classList.toggle('is-stuck', sticks && s.top < top - 1 && c.bottom > top + head.offsetHeight);
    }
    function queueCheck() { if (!ticking) { ticking = true; requestAnimationFrame(checkStuck); } }
    window.addEventListener('scroll', function () { hidePeekNow(); queueCheck(); }, { passive: true });
    window.addEventListener('resize', queueCheck);
    checkStuck();

    // Part popup
    var kitNames = Array.prototype.map.call(head.querySelectorAll('.cs-kc__k'), function (th) { return th.textContent.trim(); });
    function includedIn(row) {
      var inc = [], opt = [];
      Array.prototype.forEach.call(row.querySelectorAll('td'), function (td, i) {
        if (td.querySelector('.cs-kc__opt')) opt.push(kitNames[i]);
        else if (td.textContent.trim() || td.querySelector('.cs-kc__ck')) inc.push(kitNames[i]);
      });
      var out = inc.length ? 'Included in: ' + inc.join(', ') + '.' : '';
      if (opt.length) out += (out ? ' ' : '') + 'Optional on: ' + opt.join(', ') + '.';
      return out;
    }
    function openPart(key, row) {
      var p = PARTS[key];
      if (!p) return;
      // Hide the photo until the new one has loaded, so the previous part's photo never shows
      var img = sheet.querySelector('.cs-kc-sheet__photo');
      if (img.getAttribute('src') !== p.img) {
        img.classList.add('is-loading');
        img.onload = img.onerror = function () { img.classList.remove('is-loading'); };
        img.src = p.img;
        if (img.complete && img.naturalWidth) img.classList.remove('is-loading');
      }
      img.alt = p.name;
      sheet.querySelector('.cs-kc-sheet__name').textContent = p.name;
      sheet.querySelector('.cs-kc-sheet__blurb').textContent = p.blurb;
      sheet.querySelector('.cs-kc-sheet__price').textContent = p.price;
      sheet.querySelector('.cs-kc-sheet__in').textContent = includedIn(row);
      var box = sheet.querySelector('.cs-kc-sheet__links');
      box.textContent = '';
      (p.links || []).forEach(function (l) {
        var a = document.createElement('a');
        a.className = 'cs-kc-sheet__link';
        a.href = l[1];
        a.textContent = l[0];
        box.appendChild(a);
      });
      hidePeekNow();
      if (window.matchMedia('(min-width: 600px)').matches) sheet.style.setProperty('--kc-sheet-top', sheetTop() + 'px');
      if (sheet.showModal) sheet.showModal(); else sheet.setAttribute('open', '');
    }
    // Computer popup: top edge 24px below the header bars showing right now
    // (site header, and the desktop nav bar when it's visible), wherever the page is scrolled
    function sheetTop() {
      var bottom = 0;
      Array.prototype.forEach.call(document.querySelectorAll('.shopify-section__header, #cs-secondary-nav'), function (el) {
        var r = el.getBoundingClientRect();
        if (r.height && r.bottom > bottom && getComputedStyle(el).visibility !== 'hidden') bottom = r.bottom;
      });
      return Math.round(Math.min(bottom, window.innerHeight * 0.4)) + 24;
    }
    Array.prototype.forEach.call(body.querySelectorAll('tbody th[data-part]'), function (th) {
      var key = th.dataset.part, p = PARTS[key];
      if (!p) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cs-kc__part';
      btn.textContent = th.textContent.trim();
      btn.addEventListener('click', function () { openPart(key, th.parentNode); });
      // Start loading the photo as soon as a finger or mouse button goes down, before the tap or click finishes
      btn.addEventListener('pointerdown', function () { preload(p.img); });
      btn.addEventListener('mouseenter', function () { peekAt(p.img, th, false); });
      btn.addEventListener('mouseleave', hidePeek);
      th.textContent = '';
      th.appendChild(btn);
    });
    sheet.querySelector('.cs-kc-sheet__close').addEventListener('click', function () { sheet.close(); });
    sheet.addEventListener('click', function (e) { if (e.target === sheet) sheet.close(); });

    // Hover photo (mouse only): photos load the first time the mouse enters the chart
    var peekTimer = null, hideTimer = null, peekSeq = 0, ready = {}, preloaded = false;
    function preload(src) {
      if (!src) return Promise.resolve();
      if (!ready[src]) {
        var im = new Image();
        im.src = src;
        ready[src] = im.decode ? im.decode().catch(function () {}) : Promise.resolve();
      }
      return ready[src];
    }
    function preloadParts() { Object.keys(PARTS).forEach(function (k) { preload(PARTS[k].img); }); }
    if (canHover) {
      chart.addEventListener('mouseenter', function () {
        if (preloaded) return;
        preloaded = true;
        preloadParts();
        Array.prototype.forEach.call(head.querySelectorAll('.cs-kc__k[data-photo]'), function (th) { preload(th.dataset.photo); });
      });
      Array.prototype.forEach.call(head.querySelectorAll('.cs-kc__k[data-photo]'), function (th) {
        var a = th.querySelector('a');
        a.addEventListener('mouseenter', function () { peekAt(th.dataset.photo, th, true); });
        a.addEventListener('mouseleave', hidePeek);
        a.addEventListener('click', hidePeekNow);
      });
    }
    // Once the chart has been on screen for a second, load the part photos quietly in the background,
    // so most popups open with the photo already there (skipped when the browser asks to save data)
    var saveData = navigator.connection && navigator.connection.saveData;
    if (!saveData && 'IntersectionObserver' in window) {
      var seen = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        seen.disconnect();
        setTimeout(function () { (window.requestIdleCallback || setTimeout)(preloadParts); }, 1000);
      }, { threshold: 0.2 });
      seen.observe(chart);
    }
    function peekAt(src, el, below) {
      if (!canHover || !src) return;
      var seq = ++peekSeq;
      var moving = peek.classList.contains('show');
      clearTimeout(hideTimer);
      clearTimeout(peekTimer);
      peekTimer = setTimeout(function () {
        preload(src).then(function () {
          if (seq !== peekSeq) return;
          peekImg.src = src;
          var r = el.getBoundingClientRect();
          var w = peek.offsetWidth, h = peek.offsetHeight, left, top;
          if (below) {
            left = Math.min(Math.max(8, r.left + r.width / 2 - w / 2), window.innerWidth - w - 8);
            top = r.bottom + 8;
            if (top + h > window.innerHeight - 8) top = Math.max(8, r.top - h - 8);
          } else {
            left = r.right + 10;
            if (left + w > window.innerWidth - 8) left = Math.max(8, r.left - w - 10);
            top = Math.min(Math.max(8, r.top + r.height / 2 - h / 2), window.innerHeight - h - 8);
          }
          peek.style.left = left + 'px';
          peek.style.top = top + 'px';
          peek.classList.add('show');
        });
      }, moving ? 0 : 120);
    }
    // Leaving a name: wait a moment, so moving to the next name swaps the photo instead of fading it
    function hidePeek() {
      peekSeq++;
      clearTimeout(peekTimer);
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () { peek.classList.remove('show'); }, 80);
    }
    function hidePeekNow() {
      peekSeq++;
      clearTimeout(peekTimer);
      clearTimeout(hideTimer);
      peek.classList.remove('show');
    }
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('.cs-kc-section'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  // Theme editor: set up again when the section is re-rendered
  document.addEventListener('shopify:section:load', initAll);
})();
